import {
  Autocomplete,
  Checkbox,
  Grid,
  InputLabel,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import {
  checklistCompletedOption,
  machineList,
  speciesOptions,
  vehicalCheckListOption,
  yesNoOption,
} from '../Data/HFDropDowdData';
import { harvestingMaintanceVehicalCheckListoptionList, vehicalInspectionList } from '../Data/HfInputFieldsData';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';
import DetailedM3Table from './DetailedM3Table';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';
const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};
const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};
const HfHolidayForm = ({ data, setData }) => {
  const handleChangeData = (name, value) => {
    let updatedData = {
      [name]: value,
    };
    if (name == 'missingHours') {
      updatedData = {
        [name]: value ? 1 : 0,
        nonProductiveHours: !value ? 0 : data['nonProductiveHours'],
      };
    }

    setData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <EmployeeNameField value={data['employeeName']} onChange={handleChangeData} isOperator={true} />
      <InputFields
        label="Date & Time"
        name="date_Time"
        required={true}
        value={data['date_Time']}
        textFieldType={'datetime-local'}
        width={6}
        handleIpChange={handleChangeData}
      />
      <InputFields
        label="Total Number of Days"
        name="totalNumberOfDays"
        required={true}
        value={data['totalNumberOfDays']}
        textFieldType={'number'}
        width={6}
        handleIpChange={handleChangeData}
      />
      <Typography variant="subtitle1" sx={{ padding: '1rem' }}>
        Holidays need to be approved by your Manager in advance. Enter the start date of when the holiday period begins and
        the number of holiday days taken.
      </Typography>
    </Grid>
  );
};

export default HfHolidayForm;
